import { Fragment, useEffect, useState } from "react";
import { Dialog, Popover, Transition } from "@headlessui/react";
import FilterOptionInput from "./FilterOptionInput";
import FilterRadioInput from "./FilterRadioInput";
import FilterCalendar from "./FilterCalendar";
import axios from "axios";
import "./index.css";
import { styled } from "styled-components";
import { ReactComponent as FilterIcon } from "../../assets/icons/filter.svg";

const TriggerButton = styled.button`
    color: #ffffff !important;
    font-size: 20px !important;
    background-color: transparent !important;
    background-image: none !important;
    cursor: pointer !important;
    font-family: inherit !important;
    font-feature-settings: inherit !important;
    font-variation-settings: inherit !important;
    font-size: 100% !important;
    font-weight: inherit !important;
    line-height: 0 !important;
    color: inherit !important;
    margin: 0 !important;
    padding: 0 !important;
    border: none !important;
    box-sizing: border-box !important;
    border-width: 0 !important;
    transition: 100ms !important;
    &:hover {
        transform: scale(1.1) !important;
        background-color: transparent !important;
    }
`;

const PopWrapper = styled.div`
    position: relative !important;
    width: 20px !important;
    height: 20px !important;
    font-family: "Red Hat Display" !important;
`;

const Panel = styled.div`
    position: absolute !important;
    right: -3.5rem !important;
    z-index: 10 !important;
    margin-top: 1.5rem !important;
    display: flex !important;
    padding: 0 1rem !important;
    font-family: "Red Hat Display" !important;
`;

const FilterWrapper = styled.div`
    display: flex !important;
    overflow: hidden !important;
    border-radius: 6px !important;
    background-color: #2f2c2c !important;
    font-size: 0.875rem !important;
    line-heigt: 1.5rem !important;
    color: #fff !important;
    font-family: "Red Hat Display" !important;
    &:before {
        content: "" !important;
        position: absolute !important;
        width: 26px !important;
        height: 26px !important;
        background-color: #2f2c2c !important;
        top: -13px !important;
        right: 54px !important;
        transform: rotate(45deg) !important;
    }
`;

const InerFilter = styled.div`
    display: flex;
    padding: 34px 30px;
    gap: 10px;
`;

const FilterCaldendarWrapper = styled.div`
    padding: 1rem !important;
`;

const ResetButton = styled.button`
    border: none !important;
    font-size: 16px !important;
    padding: 2px 1rem !important;
    color: #fff !important;
    text-transform: uppercase !important;
    white-space: nowrap !important;
    display: inline-block !important;
    text-decoration: none !important;
    cursor: pointer !important;
    background-color: transparent !important;
    font-family: "Red Hat Display" !important;
`;

const ApplyButton = styled.button`
    border-radius: 0.125rem !important;
    border: none !important;
    background-color: rgb(240, 90, 38) !important;
    color: #fff !important;
    font-size: 16px !important;
    padding: 2px 1rem !important;
    text-transform: uppercase !important;
    white-space: nowrap !important;
    display: inline-block !important;
    text-decoration: none !important;
    cursor: pointer !important;
    font-family: "Red Hat Display" !important;
    &:hover {
        background-color: rgb(232, 134, 77) !important;
    }
`;

const H4 = styled.h4`
    margin: 0 !important;
    font-size: 18px !important;
    font-weight: 700 !important;
    font-family: "Red Hat Display" !important;
    line-height: normal !important;
`;

const CTAWContainer = styled.div`
    display: flex;
    gap: 1rem;
    justify-content: space-between;
    font-size: 1rem;
    line-height: 1.5rem;
    color: #ffffff;
    margin-top: 2rem;
`;

export default function BrowseArtistFilter({ filter_url, api_endpoint }) {
    const [filterParam, setFilterParam] = useState({
        //1
        genre: "",
        cost: "",
        location: "",
        "event-date": "",
        nationality: "",
    });

    const [genres_filter_data, setGenres_filter_data] = useState([]); //2
    const [costs_filter_data, setCosts_filter_data] = useState([]); //3
    const [locations_filter_data, setLocations_filter_data] = useState([]); //4
    const [main_cat_filter_data, setMain_cat_filter_data] = useState([]); //5
    const [sub_cat_filter_data, setSub_cat_filter_data] = useState([]); //6
    const [nationalities_filter_data, setNationalities_filter_data] = useState([]); //7
    const [open, setOpen] = useState(false); // 7
    const [genreSelectedValue, setGenreSelectedValue] = useState({ id: "", name: "-- No Filter --" }); //8
    const [locationSelectedValue, setLocationSelectedValue] = useState({ id: "", name: "-- No Filter --" }); //9
    const [costSelectedValue, setCostSelectedValue] = useState(""); //10
    const [dateSelectedValue, setDateSelectedValue] = useState(""); //11
    const [mainCategorySelectedValue, setMainCategorySelectedValue] = useState({ id: "", name: "-- No Filter --" }); //12
    const [subCategorySelectedValue, setSubCategorySelectedValue] = useState({ id: "", name: "Select Category first" }); //13
    const [nationalitySelectedValue, setNationalitySelectedValue] = useState({ id: "0", name: "-- No Filter --" }); //14
    const [subCatList, setsubCatList] = useState([]); //14
    const [categoryURL, setCategoryURL] = useState(""); //15
    const [subCategoryURL, setSubCategoryURL] = useState(""); //16
    const [minBookingDate, setMinBookingDate] = useState(0); //17

    useEffect(async () => {
        await getFilterOptions();
    }, []);

    useEffect(() => {
        setDefaultValueFromURLParam();
    }, [main_cat_filter_data]);

    const getFilterOptions = async () => {
        try {
            const res = await axios.get(api_endpoint);
            const resData = res.data.data;
            setGenres_filter_data(resData.genres);
            setCosts_filter_data(resData.costs);
            setLocations_filter_data(resData.locations);
            setMain_cat_filter_data([{ id: "", name: "-- No Filter --" }, ...resData.main_categories_filter]);
            setNationalities_filter_data(resData.nationalities);
            // setMain_cat_filter_data((prevCat) => resData.main_categories_filter);
            setSub_cat_filter_data(resData.sub_categories_filter);
            setMinBookingDate(resData.min_booking_date);
            window.MINBOOKINGDATE = resData.min_booking_date;
        } catch (error) {}
    };

    const setDefaultValueFromURLParam = () => {
        const setSearchParam = (paramKey, transformFn, setSelectedValueFn) => {
            if (searchParams.has(paramKey)) {
                const paramValue = searchParams.get(paramKey);
                setFilterParam((prevFilterParam) => ({
                    ...prevFilterParam,
                    [paramKey]: paramValue,
                }));

                if (!transformFn) {
                    setSelectedValueFn(paramValue);
                    return;
                }
                const filteredData = transformFn();
                const selectedValue = filteredData.find((val) => val.id == paramValue);
                setSelectedValueFn(selectedValue);
            }
        };

        const searchParams = new URLSearchParams(window.location.search);

        setSearchParam("genre", transformGenreFilterData, setGenreSelectedValue);
        setSearchParam("location", transformLocationFilterData, setLocationSelectedValue);

        if (searchParams.has("cost")) {
            const paramValue = searchParams.get("cost");
            const selectedValue = costs_filter_data.find((val) => val.join("-") == paramValue);

            // Update state with the new filter parameter
            setFilterParam((prevFilterParam) => ({
                ...prevFilterParam,
                cost: paramValue,
            }));
            setCostSelectedValue(selectedValue.join("-"));
        }

        setSearchParam("event-date", null, setDateSelectedValue);
        if (main_cat_filter_data.length > 0) {
            setMainCategorySelectedValue({ id: "", name: "-- No Filter --" });
            setsubCatList([{ id: "", name: "Select Category first" }]);
            setSubCategorySelectedValue({ id: "", name: "Select Category first" });
            // setCategoryURL(main_cat_filter_data[0].slug);
            // setSubCategoryURL(sub_cat_filter_data[main_cat_filter_data[0].id][0].slug);
        }
    };

    const transformLocationFilterData = () => {
        const locations = locations_filter_data.map(({ state_display, state_text }) => ({
            id: state_display || state_text,
            name: state_display || state_text,
        }));

        locations.unshift({
            id: "",
            name: "-- No Filter --",
        });

        return locations;
    };

    const transformGenreFilterData = () => {
        const _genres_filter_data = [...genres_filter_data];
        _genres_filter_data.unshift({
            id: "",
            name: "-- No Filter --",
        });
        return _genres_filter_data;
    };

    const updateFilterParam = (type, value) => {
        const _filterParam = { ...filterParam };
        _filterParam[type] = value;
        setFilterParam(_filterParam);
    };

    const filterSelectedHandler = (filter, type) => {
        if (type === "genre") {
            setGenreSelectedValue(filter);
        } else if (type === "location") {
            setLocationSelectedValue(filter);
        } else if (type === "mainCat") {
            setMainCategorySelectedValue(filter);
            setCategoryURL(filter.slug);
            if (filter.id == "") {
                setsubCatList([{ id: "", name: "-- No Filter --" }]);
                setSubCategorySelectedValue({ id: "", name: "-- No Filter --" });
            } else {
                setsubCatList(sub_cat_filter_data[filter.id]);
                setSubCategorySelectedValue(sub_cat_filter_data[filter.id][0]);
                setSubCategoryURL(sub_cat_filter_data[filter.id][0].slug);
            }
            return;
        } else if (type === "subCat") {
            setSubCategorySelectedValue(filter);
            setSubCategoryURL(filter.slug);
            return;
        } else if (type === "nationality") {
            setNationalitySelectedValue(filter);
        }
        updateFilterParam(type, filter.id);
    };

    const costChangeHandler = (e) => {
        const value = e.target.value;
        setCostSelectedValue(value);
        updateFilterParam("cost", value);
    };

    const filterDateSelectedhandler = (date) => {
        setDateSelectedValue(date);
        updateFilterParam("event-date", date);
    };

    function encodeQuery(data) {
        return Object.entries(data)
            .filter(([key, value]) => value !== "")
            .map(([key, value]) => `${encodeURIComponent(key)}=${encodeURIComponent(value)}`)
            .join("&");
    }

    const doFilterHandler = () => {
        if (!categoryURL) {
            alert("Please select a package");
            return;
        }
        const query_params = encodeQuery(filterParam);
        let redirect_url = `${filter_url}?${query_params}`;
        if (categoryURL != "") {
            redirect_url = `${filter_url}${categoryURL}`;
            if (subCategoryURL != "" && subCategoryURL != "nofilter") {
                redirect_url = `${redirect_url}/${subCategoryURL}`;
            }
        }
        if (query_params) {
            redirect_url = `${redirect_url}?${query_params}`;
        }
        window.location.href = redirect_url;
    };

    const clearFilterHandler = () => {
        const NO_FILTER = {
            id: "",
            name: "-- No Filter --",
        };
        setGenreSelectedValue(NO_FILTER);
        setLocationSelectedValue(NO_FILTER);
        setMainCategorySelectedValue(NO_FILTER);
        setsubCatList([NO_FILTER]);
        setCategoryURL("");
        setCostSelectedValue("");
        setDateSelectedValue("");
        setSubCategorySelectedValue(subCatList[0]);
        setFilterParam({
            genre: "",
            cost: "",
            location: "",
            "event-date": "",
            "nationality": "",
        });
    };

    return (
        <>
            {/* DESKTOP */}
            <Popover
                className="browse-artist-filter se-hidden lg:se-block"
                as={PopWrapper}>
                <Popover.Button
                    as={TriggerButton}
                    type="button"
                    id="filter-trigger-button">
                    <FilterIcon
                        height="20px"
                        width="20px"
                    />
                </Popover.Button>
                <Transition
                    as={Fragment}
                    enter="se-transition se-ease-out se-duration-200"
                    enterFrom="se-opacity-0 se-translate-y-1"
                    enterTo="se-opacity-100 se-translate-y-0"
                    leave="se-transition se-ease-in se-duration-150"
                    leaveFrom="se-opacity-100 se-translate-y-0"
                    leaveTo="se-opacity-0 se-translate-y-1">
                    <Popover.Panel as={Panel}>
                        <FilterWrapper>
                            <InerFilter>
                                <div>
                                    <H4 className="se-text-[18px] se-font-bold">Event Date</H4>
                                    <FilterCaldendarWrapper>
                                        <FilterCalendar
                                            onSelect={filterDateSelectedhandler}
                                            selectedValue={dateSelectedValue}
                                            minBookingDate={minBookingDate}
                                        />
                                    </FilterCaldendarWrapper>
                                </div>
                                <div>
                                    <FilterOptionInput
                                        onSelected={(data) => filterSelectedHandler(data, "location")}
                                        data_options={transformLocationFilterData()}
                                        label="Location"
                                        selectedValue={locationSelectedValue}
                                    />
                                    <FilterOptionInput
                                        onSelected={(data) => filterSelectedHandler(data, "mainCat")}
                                        data_options={main_cat_filter_data}
                                        label="Package*"
                                        className="se-mt-4"
                                        selectedValue={mainCategorySelectedValue}
                                    />
                                    <FilterOptionInput
                                        onSelected={(data) => filterSelectedHandler(data, "subCat")}
                                        data_options={subCatList}
                                        label="Category"
                                        className="se-mt-4"
                                        selectedValue={subCategorySelectedValue}
                                    />

                                    <FilterOptionInput
                                        onSelected={(data) => filterSelectedHandler(data, "genre")}
                                        data_options={transformGenreFilterData()}
                                        label="Genre"
                                        className="se-mt-4"
                                        selectedValue={genreSelectedValue}
                                    />
                                    <FilterOptionInput
                                        onSelected={(data) => filterSelectedHandler(data, "nationality")}
                                        data_options={nationalities_filter_data}
                                        label="Nationality"
                                        className="se-mt-4"
                                        selectedValue={nationalitySelectedValue}
                                    />
                                    <FilterRadioInput
                                        costs_filter_data={costs_filter_data}
                                        onSelected={costChangeHandler}
                                        selectedValue={costSelectedValue}
                                        className="se-mr-[28px] se-mt-4"
                                    />
                                    <CTAWContainer>
                                        <Popover.Button
                                            style={{ border: 0, color: "#fff", fontSize: "16px", lineHeight: "24px", backgroundColor: "#878383", padding: "2px 16px", borderRadius: "2px" }}
                                            type="button">
                                            Close
                                        </Popover.Button>
                                        <div
                                            className="se-flex se-gap-4 se-justify-end"
                                            style={{ display: "flex", gap: "1rem", justifyContent: "flex-end" }}>
                                            <ResetButton
                                                type="button"
                                                onClick={clearFilterHandler}>
                                                Clear
                                            </ResetButton>
                                            <ApplyButton
                                                onClick={doFilterHandler}
                                                type="button">
                                                Continue
                                            </ApplyButton>
                                        </div>
                                    </CTAWContainer>
                                </div>
                            </InerFilter>
                        </FilterWrapper>
                    </Popover.Panel>
                </Transition>
            </Popover>

            {/* MOBILE */}
            <div className="lg:se-hidden">
                <TriggerButton onClick={() => setOpen(true)}>
                    <FilterIcon
                        height="20px"
                        width="20px"
                    />
                </TriggerButton>
                <Transition.Root
                    show={open}
                    as={Fragment}>
                    <Dialog
                        as="div"
                        className="se-relative se-z-[999] browse-artist-filter"
                        onClose={setOpen}>
                        <Transition.Child
                            as={Fragment}
                            enter="se-ease-out se-duration-300"
                            enterFrom="se-opacity-0"
                            enterTo="se-opacity-100"
                            leave="se-ease-in se-duration-200"
                            leaveFrom="se-opacity-100"
                            leaveTo="se-opacity-0">
                            <div className="se-fixed se-inset-0 se-bg-gray-500 se-bg-opacity-75 se-transition-opacity" />
                        </Transition.Child>

                        <div className="se-fixed se-inset-0 se-z-[999] se-w-screen se-overflow-y-auto">
                            <div className="md:se-flex se-min-h-full se-items-end se-justify-center se-text-center sm:se-items-center sm:se-p-0">
                                <Transition.Child
                                    as={Fragment}
                                    enter="se-ease-out se-duration-300"
                                    enterFrom="se-opacity-0 se-translate-y-4 sm:se-translate-y-0 sm:se-scale-95"
                                    enterTo="se-opacity-100 se-translate-y-0 sm:se-scale-100"
                                    leave="se-ease-in se-duration-200"
                                    leaveFrom="se-opacity-100 se-translate-y-0 sm:se-scale-100"
                                    leaveTo="se-opacity-0 se-translate-y-4 sm:se-translate-y-0 sm:se-scale-95">
                                    <Dialog.Panel className="se-relative se-transform se-bg-[rgba(37,36,36,0.98)] se-px-4 se-pb-4 se-pt-5 se-text-left se-shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-lg sm:se-p-6 se-text-sneutral-450">
                                        <div className="se-flex se-overflow-hidden se-rounded-[6px] se-text-sm se-leading-6 se-shadow-lg">
                                            <div className="se-p-4 se-w-full">
                                                <div>
                                                    <H4 className="se-text-[18px] se-font-bold">Event Date</H4>
                                                    <FilterCaldendarWrapper>
                                                        <FilterCalendar
                                                            onSelect={filterDateSelectedhandler}
                                                            selectedValue={dateSelectedValue}
                                                            minBookingDate={minBookingDate}
                                                        />
                                                    </FilterCaldendarWrapper>
                                                </div>
                                                <div className="se-flex se-gap-5 se-flex-col lg:se-flex-row">
                                                    <FilterOptionInput
                                                        onSelected={(data) => filterSelectedHandler(data, "location")}
                                                        data_options={transformLocationFilterData()}
                                                        label="Location"
                                                        selectedValue={locationSelectedValue}
                                                    />
                                                    <FilterOptionInput
                                                        onSelected={(data) => filterSelectedHandler(data, "mainCat")}
                                                        data_options={main_cat_filter_data}
                                                        label="Package*"
                                                        className=""
                                                        selectedValue={mainCategorySelectedValue}
                                                    />
                                                    <FilterOptionInput
                                                        onSelected={(data) => filterSelectedHandler(data, "subCat")}
                                                        data_options={subCatList}
                                                        label="Category"
                                                        className=""
                                                        selectedValue={subCategorySelectedValue}
                                                    />
                                                    <FilterOptionInput
                                                        onSelected={(data) => filterSelectedHandler(data, "genre")}
                                                        data_options={transformGenreFilterData()}
                                                        label="Genre"
                                                        selectedValue={genreSelectedValue}
                                                    />
                                                    <FilterOptionInput
                                                        onSelected={(data) => filterSelectedHandler(data, "nationality")}
                                                        data_options={nationalities_filter_data}
                                                        label="Nationality"
                                                        selectedValue={nationalitySelectedValue}
                                                    />
                                                    <FilterRadioInput
                                                        costs_filter_data={costs_filter_data}
                                                        onSelected={costChangeHandler}
                                                        selectedValue={costSelectedValue}
                                                    />
                                                </div>
                                                <div className="se-flex se-gap-4 se-justify-between se-text-base se-text-sneutral-450 se-mt-8">
                                                    <button
                                                        className="se-px-4 se-py-[2px] se-rounded-sm se-bg-sneutral-650 hover:se-bg-sneutral-700"
                                                        onClick={() => setOpen(false)}
                                                        type="button"
                                                        style={{ border: 0, color: "#fff", fontSize: "16px", lineHeight: "24px", backgroundColor: "#878383", padding: "2px 16px", borderRadius: "2px" }}>
                                                        Close
                                                    </button>
                                                    <div>
                                                        <button
                                                            type="button"
                                                            className="se-px-4 se-py-[2px] se-rounded-sm se-mr-4"
                                                            onClick={clearFilterHandler}
                                                            style={{ border: 0, color: "#fff", backgroundColor: "transparent", fontSize: "16px", lineHeight: "24px", padding: "2px 16px" }}>
                                                            Clear
                                                        </button>
                                                        <button
                                                            type="button"
                                                            className="se-bg-sorange-40 hover:se-bg-sorange-30 se-px-4 se-py-[2px] se-rounded-sm"
                                                            onClick={doFilterHandler}
                                                            style={{ border: 0, color: "#fff", fontSize: "16px", lineHeight: "24px", backgroundColor: "#F05A26", padding: "2px 16px", borderRadius: "2px" }}>
                                                            Continue
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </Dialog.Panel>
                                </Transition.Child>
                            </div>
                        </div>
                    </Dialog>
                </Transition.Root>
            </div>
        </>
    );
}
